import { apiConstants, EVENTS } from "../config";

let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: "CEM_00001"
                },
                url: {
                    cemeteriesFeatures: `${codeAPI}/front/map/features/cemeteries`,
                    sectorsFeatures: `${codeAPI}/front/map/features/sectors`,
                    occupationsFeatures: `${codeAPI}/front/map/features/occupations`
                }
            },
            headernav: {
                tools: [{ component: "dashboard", title: "dashboard.title" }]
            },
            cemeteries: {
                active: true,
                show: false,
                title: "cemeteries.titles",
                label: "cemeteries.label",
                acl: {
                    view: true
                },
                url: {
                    view: `${codeAPI}/front/cemeteries/read/cemeteries`
                }
            },
            cemetery: {
                active: true,
                show: false,
                title: "cemeteries.titles",
                label: "cemeteries.label",
                panel: {
                    images: {
                        main_image: true,
                        direction: "vertical",
                        max: 4,
                        new: {
                            properties: {
                                fileable_type: "cemeteries_images"
                            }
                        }
                    },
                    files: {
                        maxFiles: 5,
                        mimeTypes: [
                            "application/msword",
                            "application/vnd.ms-excel",
                            "application/vnd.ms-powerpoint",
                            "application/pdf",
                            "text/plain",
                            "image/x-png",
                            "image/bmp",
                            "image/jpeg",
                            "image/jpg",
                            "image/gif"
                        ],
                        new: {
                            properties: {
                                fileable_type: "cemeteries_files"
                            }
                        }
                    }
                },
                acl: {
                    view: true
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/read/cemeteries/:code`,
                    showDetails: `${codeAPI}/front/cemeteries/details/cemeteries/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/cemeteries/lists/:id`,
                    create: `${codeAPI}/front/cemeteries/details/cemeteries/`,
                    update: `${codeAPI}/front/cemeteries/details/cemeteries/:id`,
                    delete: `${codeAPI}/front/cemeteries/details/cemeteries/:id`
                }
            },
            sectors: {
                active: true,
                show: false,
                title: "sectors.titles",
                label: "sectors.label",
                acl: {
                    view: true
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/read/cemeteries/:cemetery.code/sectors`,
                    occupations: `${codeAPI}/front/cemeteries/read/cemeteries/:cemetery.code/sectors/:sector.id/occupations`
                }
            },
            sector: {
                active: true,
                show: false,
                title: "sectors.title",
                label: "sectors.label",
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    showDetails: `${codeAPI}/front/cemeteries/details/sectors/:id`,
                    showDetailsByCode: `${codeAPI}/front/cemeteries/details/sectors/code/:code`,
                    create: `${codeAPI}/front/cemeteries/details/sectors`,
                    update: `${codeAPI}/front/cemeteries/details/sectors/:id`,
                    delete: `${codeAPI}/front/cemeteries/details/sectors/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/sectors/lists/:id`
                }
            },
            occupation: {
                active: true,
                show: false,
                title: "occupations.titles",
                label: "occupations.label",
                panel: {
                    images: {
                        main_image: true,
                        direction: "vertical",
                        max: 4,
                        new: {
                            properties: {
                                fileable_type: "occupations_images"
                            }
                        }
                    },
                    files: {
                        maxFiles: 5,
                        mimeTypes: [
                            "application/msword",
                            "application/vnd.ms-excel",
                            "application/vnd.ms-powerpoint",
                            "application/pdf",
                            "text/plain",
                            "image/x-png",
                            "image/bmp",
                            "image/jpeg",
                            "image/jpg",
                            "image/gif"
                        ],
                        new: {
                            properties: {
                                fileable_type: "occupations_files"
                            }
                        }
                    }
                },
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/read/occupations/:id`,
                    showDetails: `${codeAPI}/front/cemeteries/details/occupations/:id`,
                    showDetailsByCode: `${codeAPI}/front/cemeteries/details/occupations/code/:code`,
                    create: `${codeAPI}/front/cemeteries/details/occupations`,
                    update: `${codeAPI}/front/cemeteries/details/occupations/:id`,
                    delete: `${codeAPI}/front/cemeteries/details/occupations/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/occupations/lists/:id`
                }
            },
            interment: {
                active: true,
                show: false,
                title: "interments.titles",
                label: "interments.label",
                panel: {
                    files: {
                        maxFiles: 5,
                        mimeTypes: [
                            "application/msword",
                            "application/vnd.ms-excel",
                            "application/vnd.ms-powerpoint",
                            "application/pdf",
                            "text/plain",
                            "image/x-png",
                            "image/bmp",
                            "image/jpeg",
                            "image/jpg",
                            "image/gif"
                        ],
                        new: {
                            properties: {
                                fileable_type: "occupation_interments_files"
                            }
                        }
                    }
                },
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/details/interments/:id`,
                    create: `${codeAPI}/front/cemeteries/details/interments?withData`,
                    update: `${codeAPI}/front/cemeteries/details/interments/:id?withData`,
                    delete: `${codeAPI}/front/cemeteries/details/interments/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/interments/lists/:id`,
                    lookup: `${codeAPI}/front/cemeteries/details/interments/lookup/:model`,
                    showDetails: `${codeAPI}/front/cemeteries/details/interments/:id`,
                    default: `${codeAPI}/front/cemeteries/details/interments/default?data={"occupation_id": :occupation_id}`
                }
            },
            deed_owner: {
                active: true,
                show: false,
                title: "deed_owners.titles",
                label: "deed_owners.label",
                panel: {
                    files: {
                        maxFiles: 5,
                        mimeTypes: [
                            "application/msword",
                            "application/vnd.ms-excel",
                            "application/vnd.ms-powerpoint",
                            "application/pdf",
                            "text/plain",
                            "image/x-png",
                            "image/bmp",
                            "image/jpeg",
                            "image/jpg",
                            "image/gif"
                        ],
                        new: {
                            properties: {
                                fileable_type: "occupation_deed_owners_files"
                            }
                        }
                    }
                },
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/details/deedowners/:id`,
                    create: `${codeAPI}/front/cemeteries/details/deedowners?withData`,
                    update: `${codeAPI}/front/cemeteries/details/deedowners/:id?withData`,
                    delete: `${codeAPI}/front/cemeteries/details/deedowners/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/deedowners/lists/:id`,
                    showDetails: `${codeAPI}/front/cemeteries/details/deedowners/:id`,
                    default: `${codeAPI}/front/cemeteries/details/deedowners/default?data={"occupation_id": :occupation_id}`,
                    lookup: `${codeAPI}/front/cemeteries/details/deedowners/lookup/:model/:id`
                }
            },
            deed_owner_holder: {
                active: true,
                show: false,
                title: "deed_owner_holders.titles",
                label: "deed_owner_holders.label",
                panel: {},
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    show: `${codeAPI}/front/cemeteries/details/deedownerholders/:id`,
                    create: `${codeAPI}/front/cemeteries/details/deedownerholders`,
                    update: `${codeAPI}/front/cemeteries/details/deedownerholders/:id`,
                    delete: `${codeAPI}/front/cemeteries/details/deedownerholders/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/deedownerholders/lists/:id`,
                    lookup: `${codeAPI}/front/cemeteries/details/deedownerholders/lookup/:model`,
                    showDetails: `${codeAPI}/front/cemeteries/details/deedownerholders/:id`,
                    default: `${codeAPI}/front/cemeteries/details/deedownerholders/default?data={"occupation_deed_owner_id": :occupation_deed_owner_id}`
                }
            },
            entity: {
                active: true,
                show: false,
                title: "entities.title",
                label: "entities.label",
                acl: {
                    view: null,
                    show: null,
                    add: null,
                    edit: null,
                    delete: null,
                    export: null
                },
                url: {
                    showDetails: `${codeAPI}/front/cemeteries/details/entities/:id`,
                    create: `${codeAPI}/front/cemeteries/details/entities`,
                    update: `${codeAPI}/front/cemeteries/details/entities/:id`,
                    delete: `${codeAPI}/front/cemeteries/details/entities/:id`,
                    lists: `${codeAPI}/front/cemeteries/details/entities/lists/:id`
                }
            }
        },
        tools: {
            backoffice: {
                active: true,
                title: "backoffice.titles",
                label: "backoffice.label",
                panel: {
                    show: false
                },
                acl: {
                    view: "GU_00076"
                },
                url: {
                    view: `:moduleCodegestao.home`
                }
            },
            layerswitcher: {
                acl: {
                    view: "GU_00079"
                }
            },
            streetview: {
                acl: {
                    view: "GU_00078"
                }
            },
            annotations: {
                acl: {
                    view: "GU_00125"
                }
            },
            layers: {
                active: true,
                title: "layers.titles",
                label: "layers.label",
                panel: {
                    show: false,
                    loaded: false
                },
                acl: {
                    view: "GU_00074"
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`
                },
                selected: null
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false
                },
                acl: {
                    view: "GU_00077"
                }
            },
            regulations: {
                active: true,
                title: "regulations.titles",
                label: "regulations.label",
                panel: {
                    show: false,
                    loaded: false
                },
                acl: {
                    view: "GU_00083"
                },
                url: {
                    getData: `${codeAPI}/front/regulations`
                }
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [
                        {
                            id: "addr",
                            name: "navsearch.address.title",
                            url: "../gateway/address/search",
                            listGroup: "adminName1",
                            labelTemplate: "navsearch.address.labelTemplate",
                            subLabelTemplate: null,
                            placeholder: "navsearch.address.placeholder"
                        }
                    ],
                    search: {
                        category: null,
                        item: null,
                        search: null
                    }
                }
            },
            navsearch_advanced: {
                active: false,
                title: "navsearch.advanced.title",
                panel: {
                    event: EVENTS.SHOW_ADVANCED_SEARCH
                },
                acl: {
                    view: null
                },
                url: {
                    search: `${codeAPI}/front/cemeteries/read/search/advanced?data=:data`,
                    lists: `${codeAPI}/front/cemeteries/read/search/advanced/lists`
                }
            },
            catalog: {
                acl: {
                    view: "GU_00081"
                }
            },
            identify: {
                acl: {
                    view: "GU_00082"
                }
            },
            dashboard: {
                active: true,
                title: "dashboard.titles",
                label: "dashboard.label",
                panel: {
                    show: false,
                    loaded: false
                },
                acl: {
                    view: "GU_00077"
                },
                url: {
                    getLists: `${codeAPI}/cemeteries/sectors/search/lists`
                }
            },
            print_visible_emissions: {
                active: true,
                title: "print_visible_emissions.titles",
                label: "print_visible_emissions.titles",
                panel: {
                    show: false,
                    loaded: false
                },
                acl: {
                    view: "GU_00080"
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`
                }
            },
            search: {
                active: true,
                title: "search.titles",
                label: "search.label",
                panel: {
                    show: false,
                    loaded: false,
                    allowExportData: true
                },
                acl: {
                    view: null,
                    export: null
                },
                url: {
                    listsDefault: `${codeAPI}/front/cemeteries/read/search/lists`,
                    listsSectors: `${codeAPI}/front/cemeteries/read/sectors/search/lists`,
                    listsOccupations: `${codeAPI}/front/cemeteries/read/occupations/search/lists`,
                    listsInterments: `${codeAPI}/front/cemeteries/read/interments/search/lists`,
                    listsEntities: `${codeAPI}/front/cemeteries/read/entities/search/lists`
                }
            },
            search_sectors: {
                active: true,
                title: "sectors.titles",
                panel: {
                    show: false,
                    feature: {
                        idProperty: "id",
                        geometryProperty: "geojson",
                        preserveGeometry: false
                    }
                },
                acl: {
                    view: null,
                    export: null
                },
                url: {
                    search: `${codeAPI}/front/cemeteries/read/sectors/search`
                }
            },
            search_occupations: {
                active: true,
                title: "sectors.titles",
                panel: {
                    show: false,
                    feature: {
                        idProperty: "id",
                        geometryProperty: "geojson",
                        preserveGeometry: false
                    }
                },
                acl: {
                    view: null,
                    export: null
                },
                url: {
                    search: `${codeAPI}/front/cemeteries/read/occupations/search`
                }
            },
            search_interments: {
                active: true,
                title: "interments.titles",
                panel: {
                    show: false,
                    feature: {
                        idProperty: "id",
                        geometryProperty: "geojson",
                        preserveGeometry: false
                    }
                },
                acl: {
                    view: null,
                    export: null
                },
                url: {
                    search: `${codeAPI}/front/cemeteries/read/interments/search`
                }
            },
            search_entities: {
                active: true,
                title: "entities.titles",
                panel: {
                    show: false
                },
                acl: {
                    view: null,
                    export: null
                },
                url: {
                    search: `${codeAPI}/front/cemeteries/read/entities/search`
                }
            },
            features: {
                active: true,
                select: {
                    zoom: 0.352777587277881,
                    duration: 3500,
                    hitTolerance: 2
                },
                tooltip: {
                    active: false,
                    template: '<p class="title">:name</p>'
                },
                acl: {
                    view: true
                }
            }
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    search: {
                        source: "vs_search",
                        layer: "lyr_search",
                        zindex: 1000,
                        timeout: 10000,
                        duration: 1500,
                        zoomScale: 1.3
                    },
                    cluster: {
                        zindex: 8
                    },
                    flash: {
                        layer: "lyr_flash",
                        source: "vs_flash",
                        zindex: 16,
                        timeout: 5000
                    },
                    cemeteries: {
                        layer: "lyr_cemeteries",
                        source: "vs_cemeteries",
                        cluster: "cl_cemeteries",
                        zindex: 16,
                        zoomScale: 1.25,
                        scale: 1,
                        scaleSelected: 1,
                        selectedProperty: "highlight", //'selected'
                        duration: 1500,
                        timeout: 5000,
                        // minZoom: 10, // visible at zoom levels above XX
                        // maxZoom: 14, // visible at zoom levels XX and below
                        minResolution: 0.99, // The minimum resolution (inclusive) at which this layer will be visible.
                        // maxResolution:  null, // The maximum resolution (exclusive) below which this layer will be visible.
                        declutter: false,
                        interactions: [
                            // 'tooltip',
                            "select"
                        ]
                    },
                    sectors: {
                        layer: "lyr_sectors",
                        source: "vs_sectors",
                        zindex: 14,
                        zoomScale: 1.25,
                        scale: 1,
                        scaleSelected: 1,
                        selectedProperty: "highlight", //'selected'
                        duration: 1500,
                        timeout: 5000,
                        bboxStrategy: true, // to active bboxStrategy
                        // minZoom: 10, // visible at zoom levels above XX
                        // maxZoom: 14, // visible at zoom levels XX and below
                        // minResolution:  null, // The minimum resolution (inclusive) at which this layer will be visible.
                        maxResolution: 0.99, // The maximum resolution (exclusive) below which this layer will be visible.
                        declutter: true,
                        interactions: [
                            // 'select',
                        ]
                    },
                    occupations: {
                        layer: "lyr_occupations",
                        source: "vs_occupations",
                        zindex: 15,
                        zoomScale: 1.25,
                        scale: 1,
                        scaleSelected: 1,
                        selectedProperty: "highlight", //'selected'
                        duration: 1500,
                        timeout: 5000,
                        bboxStrategy: true,
                        maxResolution: 0.10583333344128333, // 300 (exclusive)
                        declutter: false,
                        interactions: ["select"]
                    }
                },
                style: {
                    cemeteries: {
                        // image: {
                        //     src: require(`../../images/mark.svg`),
                        //     scale: 1,
                        // },
                        icon: {
                            src: require(`../../images/mark.svg`),
                            scale: 1
                        },
                        // circle: {
                        //     // src: require(`../../images/mark.svg`),
                        //     // scale: 1,
                        //     radius: 15,
                        //     displacement: [
                        //         -7.5,
                        //         0,
                        //     ],
                        //     fill: {
                        //         color: 'red',
                        //     },
                        //     stroke: {
                        //         color: 'white',
                        //         width: 0.5,
                        //     }
                        // },
                        cluster: {
                            src: require(`../../images/cluster.svg`)
                        },
                        text: {
                            font: "bold 12px Arial, sans-serif",
                            align: "left",
                            baseline: "middle",
                            placement: "point",
                            value: ["get", "name"], //':name',
                            fill: {
                                color: "#181429"
                            },
                            stroke: {
                                color: "#ffffff",
                                width: 2
                            },
                            offset: {
                                x: 20,
                                y: 0
                            }
                        },
                        // stroke: [
                        //     {
                        //         color: '#ffffff',
                        //         width: 5,
                        //     },
                        //     {
                        //         color: '#0099ff',
                        //         width: 3,
                        //     },
                        // ],
                        fill: {
                            color: "#ffffff80"
                        }
                    },
                    sectors: [
                        {
                            filter: ["<=", ["resolution"], 0.2293055557894472], //650
                            style: {
                                text: {
                                    value: ["get", "number"],
                                    font: "bold 16px Arial, Verdana, Helvetica, sans-serif",
                                    fillColor: "rgba(53,121,177,1)",
                                    strokeColor: "#fff",
                                    strokeWidth: 2,
                                    textAlign: "center",
                                    textBaseline: "middle",
                                    overflow: true,
                                    declutterMode: "declutter"
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "sector_type_id"], 1], // Jazigo
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(244,165,130,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    lineCap: "round",
                                    lineJoin: "round",
                                    lineDash: [15, 8, 5, 8],
                                    lineDashOffset: 0
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "sector_type_id"], 2], // Talhão
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(33,102,172,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    lineCap: "round",
                                    lineJoin: "round",
                                    lineDash: [15, 8, 5, 8],
                                    lineDashOffset: 0
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "sector_type_id"], 3], // Ossário
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(146,197,222,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    lineCap: "round",
                                    lineJoin: "round",
                                    lineDash: [15, 8, 5, 8],
                                    lineDashOffset: 0
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "sector_type_id"], 4], // Columbário
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(178,24,43,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    line: {
                                        cap: "round",
                                        join: "round",
                                        dash: [15, 8, 5, 8],
                                        DashOffset: 0
                                    }
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "sector_type_id"], 5], // Nicho
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(253,219,199,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    lineCap: "round",
                                    lineJoin: "round",
                                    lineDash: [15, 8, 5, 8],
                                    lineDashOffset: 0
                                }
                            }
                        },
                        {
                            else: true, // Sem informação
                            style: {
                                stroke: {
                                    width: 2,
                                    color: "rgba(108,102,98,1)",
                                    offset: 0,
                                    miterLimit: 10,
                                    lineCap: "round",
                                    lineJoin: "round",
                                    lineDash: [15, 8, 5, 8],
                                    lineDashOffset: 0
                                }
                            }
                        }
                    ],
                    occupations: [
                        {
                            filter: [
                                "any",
                                [
                                    "all",
                                    // ['<=', ['resolution'], 0.03527777781376111],
                                    ["<=", ["resolution"], 0.052916666720641665], // 150
                                    ["!=", ["get", "occupation_type_id"], 2],
                                    ["!=", ["get", "occupation_type_id"], 3],
                                    ["!=", ["get", "occupation_type_id"], 4],
                                    ["!=", ["get", "occupation_type_id"], 5],
                                    ["!=", ["get", "occupation_type_id"], 6],
                                    ["!=", ["get", "occupation_type_id"], 9]
                                ],
                                [
                                    "all",
                                    ["<=", ["resolution"], 0.03527777781376111], // 100
                                    ["!=", ["get", "occupation_type_id"], 2],
                                    ["!=", ["get", "occupation_type_id"], 4],
                                    ["!=", ["get", "occupation_type_id"], 6],
                                    ["!=", ["get", "occupation_type_id"], 9]
                                ],
                                [
                                    "all",
                                    ["<=", ["resolution"], 0.017638888906880555], // 50
                                    ["!=", ["get", "occupation_type_id"], 4],
                                    ["!=", ["get", "occupation_type_id"], 6]
                                ],
                                ["<=", ["resolution"], 0.0035277777813761] // 10
                            ],
                            style: {
                                text: {
                                    value: ["get", "number"],
                                    font: "bold 11px Arial, Verdana, Helvetica, sans-serif",
                                    fillColor: "rgba(0,0,0,1)",
                                    strokeColor: "#fff",
                                    strokeWidth: 2,
                                    textAlign: "center",
                                    textBaseline: "middle",
                                    offsetY: -10,
                                    declutterMode: "declutter"
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 1], // Sepultura Perpétua
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(5,48,97,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 2], // Ossário Anual
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(146,197,222,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 3], // Jazigo Particular
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(214,96,77,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 4], // Columbário Anual
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(103,0,31,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 5], // Jazigo Municipal
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(244,165,130,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 6], // Columbário Perpétuo
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(178,24,43,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 7], // Sepultura Temporária
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(33,102,172,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 8], // Nicho Jazigo
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(254,239,230,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            filter: ["==", ["get", "occupation_type_id"], 9], // Ossário  Perpétuo
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(67,147,195,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        },
                        {
                            else: true,
                            style: {
                                circle: {
                                    radius: 3,
                                    fillColor: "rgba(135,131,122,1)",
                                    strokeColor: "white",
                                    strokeWidth: 0.5
                                }
                            }
                        }
                    ]
                },
                interactions: {
                    draw: {}
                }
            }
        },
        config: {}
    }
};

export default state;
